import { Component, OnInit, Inject } from "@angular/core";
import
{
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { HttpService } from "../../../services/http/http.service";
import { ErrorHandlingService } from "../../../services/error-handling/error-handling.service";
import { ActivitylogService } from '../../../services/activitylog/activitylog.service';
import { ValidationService } from "../../../services/validations/validation.service";
import { JsonDataService } from "../../../services/commonData/json-data.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CommonModule } from "@angular/common";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Router } from "@angular/router";
import { SessionStorageService } from "ngx-webstorage";
@Component({
  selector: "app-change-password-modal",
  standalone: true,
  templateUrl: "./change-password-modal.component.html",
  styleUrls: ["./change-password-modal.component.css"],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatCardModule, MatIconModule]
})
export class ChangePasswordModalComponent implements OnInit
{
  public loading = false;
  disabled = false;
  hide1=true;
 hide2=true;
  enteredNumcount:any;
  enteredspecialcount:any ;
  enteredAlphcount:any;
  alertMessage:any;
  alertMessageText:any;
  passwordLength:any;
  passwordNumeric:any;
  passwordSpecialChar:any;
  passwordAlphabetCaps:any;
  response: any;
  pattern: any;
  bln_loading:boolean = false;
  int_maxLen_password:any;
  str_oldpwd:any;
  // creating instance of form
  ChangePass = new FormGroup({
    userID: new FormControl(),
    userPassword: new FormControl(),
    userConfirmPassword: new FormControl()
  });

  constructor(
    public router: Router,
    private http: HttpService,
        public sessionStorage: SessionStorageService,
    private errorHandling?: ErrorHandlingService,
    private _formBuilder?: FormBuilder,
    public activityLog?: ActivitylogService,
    private validation?: ValidationService,
    private jsonDataService?: JsonDataService,
    private dialogRef?: MatDialogRef<ChangePasswordModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: any
  ) {

   }

     // Avoid Special Characters
  omit_special_char(event:any)
  {
    var k;
    k = event.charCode;  //
    return (k != 33 && k != 126 && k != 96 && k != 40 && k != 41 && k != 34 && k != 39 && k != 44 && k != 47 && k != 59 && k != 60
      && k != 61 && k != 62 && k != 91 && k != 93 && k != 123 && k != 125 && k != 124 && k != 92);
  }
 
   createForm(value:any){
    this.ChangePass = this._formBuilder!.group({
      userID: [this.data.UserID, [Validators.required]],
      userPassword: ['', [Validators.pattern(value),this.validation?.requiredField]],
      userConfirmPassword: ['', [this.validation?.requiredField, matchOtherValidator('userPassword')]]
    });
   }

   allowCharactersInInputFields(event:any)
   {
     this.validation?.allowCharactersInInputFields(event);
   }

  passwordKey(event: any)
  {
    const value = event.target.value;
    this.enteredNumcount = (value.match(/\d/g) || []).length;
    this.enteredspecialcount = (value.match(/[~`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g) || []).length;
    this.enteredAlphcount = value.length - value.replace(/[A-Z]/g, '').length;
    if (value.length < this.passwordLength)
    {
      this.alertMessage = true;
      this.alertMessageText = 'Password should Contain Minimum ' + this.passwordLength + '  Letters';
    } else if (((this.enteredspecialcount < this.passwordSpecialChar) || (this.enteredspecialcount == 0)) && (this.passwordSpecialChar != 0))
    {
      this.alertMessage = true;
      this.alertMessageText = 'Password should Contain Atleast ' + this.passwordSpecialChar + ' Special Characters';
    } else if (((this.enteredNumcount < this.passwordNumeric) || (this.enteredNumcount == 0)) && (this.passwordNumeric != 0))
    {
      this.alertMessage = true;
      this.alertMessageText = 'Password should Contain Atleast ' + this.passwordNumeric + ' Number';
    }
    else if (((this.enteredAlphcount < this.passwordAlphabetCaps) || (this.enteredAlphcount == 0)) && (this.passwordAlphabetCaps != 0))
    {
      this.alertMessage = true;
      this.alertMessageText = 'Password should Contain Atleast ' + this.passwordAlphabetCaps + ' Capital Letter';
    }
    else
    {
      this.alertMessage = false;
    }
  }

  onNoClick(): void
  {
    this.dialogRef!.close();
  }

  ngOnInit() {
  
      this.ChangePass = this._formBuilder!.group({
        userID: [this.data.UserID, [Validators.required]],
        userPassword: ['', [Validators.required]],
        userConfirmPassword: ['', [Validators.required, matchOtherValidator('userPassword')]]
      });

      var obj = {
        UserID:this.data.UserID
      }
      this.http.postMethod('login/getPassword',obj).subscribe((res:any)=>{
      this.str_oldpwd=res.data.resultOld[0].realPassword;
      this.response = res.data.result[0];
      this.passwordLength=  this.response.Pwd_Length;
      this.passwordNumeric= this.response.Pwd_Digit;
      this.passwordSpecialChar= this.response.Pwd_SpecialChr;
      this.passwordAlphabetCaps= this.response.Pwd_Alphabate;
      this.pattern='^(?=(?:[^A-Z]*[A-Z]){'+this.passwordAlphabetCaps+'})(?=(?:[^!@#$%^&*()]*[!@#$%^&*()]){'+this.passwordSpecialChar+'})(?=(?:[^0-9]*[0-9]){'+this.passwordNumeric+'}).{'+this.passwordLength+',}$';
      this.createForm(this.pattern);
    }, err =>
    {
      this.errorHandling?.checkError(err.status);
      this.bln_loading=false;
    });

    this.jsonDataService?.getValueFromJSON().then((res: any) =>
    {
      this.int_maxLen_password = res.InputField.find((x:any) => x.Name === 'PasswordMaxLength').Value;
    }).catch(err =>
    {
    });
   }
    // controls for the form
  get userID() { return this.ChangePass.get('userID'); }
  get userPassword() { return this.ChangePass.get('userPassword'); }
  get userConfirmPassword() { return this.ChangePass.get('userConfirmPassword'); }

  onFormSubmit() {

    if(this.str_oldpwd == this.ChangePass.value.userPassword)
    {
       Swal.fire("New Password must be different from Previous Password", "", "warning");
    }
    else
    {
       var obj = {
      datas: this.ChangePass.value
    }

        this.bln_loading = true;
        this.http.postMethod("login/updateUserPassword", obj).subscribe(
          (res: any) => {
            this.bln_loading = false;
            if (res.result == "User Password Updated") {
              Swal.fire("User Password Updated Successfully", "", "success");

            } else {
              Swal.fire("Operation Failed", "", "warning");
            }

            this.sessionStorage.clear();
             this.btnClose_onClick();
          },
          err => {
            this.errorHandling?.checkError(err.status);
            this.bln_loading = false;
          }
        );
      
    }

  }
  reset() {
    this.ChangePass.reset();
  }
  btnClose_onClick()
  {
    this.dialogRef!.close();
  }
}
/***********************Function Detail ******************************/
/* 1) Function takes new Password as an argument and also the current conform Password as input
   2) Returns true If both same otherwise false for mismatched password
*/
/*********************Function Detail End **************************/
export function matchOtherValidator(otherControlName: string) {

  let thisControl: FormControl;
  let otherControl: FormControl;

  return function matchOtherValidate(control: FormControl) {

    if (!control.parent) {
      return null;
    }

    // Initializing the validator.
    if (!thisControl) {
      thisControl = control;
      otherControl = control.parent.get(otherControlName) as FormControl;
      if (!otherControl) {
        throw new Error('matchOtherValidator(): other control is not found in parent group');
      }
      otherControl.valueChanges.subscribe(() => {
        thisControl.updateValueAndValidity();
      });
    }

    if (!otherControl) {
      return null;
    }

    if (otherControl.value !== thisControl.value) {
      return {
        matchOther: true
      };
    }

    return null;

  };

}
